// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-overlay>DIV{color:var(--input-label)}.custom-overlay>DIV>*{padding:3px}.custom-overlay .yaml-editor{flex:1;min-height:200px}.custom-overlay .yaml-editor .code-mirror .CodeMirror{position:static;height:auto;min-height:200px}", ""]);
// Exports
module.exports = exports;
